import React, { useContext } from "react";
import { connect } from "react-redux";
import { Table } from "../../view/Table";
import AuthServerTableRow from "./AuthServerTableRow";
import AuthServerTableRowSkeleton from "./AuthServerTableRowSkeleton";
import { debug } from "../../utils";
import { TableContext } from "../../index";

function AuthServerTable({ authServers }) {

    const { config } = useContext(TableContext);

    // Client-side filtering based on searchTerm from context
    const filteredResults = authServers.filter((item) => {
        const term = (config.searchTerm || '').toLowerCase();
        if (!term) return true;

        const ip = (item.ip || '').toLowerCase();
        const baseDN = (item.baseDN || '').toLowerCase();
        const serviceName = (item.serviceName || '').toLowerCase();
        const type = (item.type || '').toLowerCase();
        const statusStr = item.status === '1' ? 'connected' : 'disconnected';

        return ip.includes(term) || baseDN.includes(term) || serviceName.includes(term) || type.includes(term) || statusStr.includes(term);
    });

    const headers = [
        { name: 'IP/HOST' },
        { name: 'BASE DN' },
        { name: 'SERVICE NAME' },
        { name: 'TYPE' },
        { name: 'STATUS' },
    ]

    return (
        <>
            <Table headers={headers} elements={filteredResults} className="mt-4">
                {config.isLoading ? (
                    Array.from(new Array(5)).map((_, index) => (
                        <AuthServerTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredResults.map((authServer, index) => <AuthServerTableRow key={index} data={authServer} index={index} />)
                )}
            </Table>
            {!config.isLoading && filteredResults.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("AuthServerTable mapStateToProps", state);
    const authPage = state.authPage;
    return {
        authServers: authPage.authServers || []
    };
}

export default connect(mapStateToProps)(AuthServerTable);
